import Cookies from 'js-cookie';


const api = Cookies.withAttributes({
    path: '/',
    domain: null,
    sameSite: 'None',
    secure: true
})

export function setCookie(name, value) {
    api.set(name, value);
}

export function getCookie(name) {
    return api.get(name);
}

export function delCookie(name) {
    return api.remove(name);
}
